import { mapActions, mapGetters, mapState } from 'vuex';
import insightPanel from '@/components/insight/insight-panel/insight-panel.vue';
import insightLink from '@/components/insight/insight-link/insight-link.vue';


export default {
  components: {
    insightPanel,
    insightLink,
  },
  props: {
    numArticles: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      linkBack: {
        name: 'insight',
      },
      createLink(url) {
        return {
          path: `/insight/${btoa(encodeURI(url))}`,
        };
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('insight', ['analysis']),
    allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: `/insight/${btoa(encodeURI('//analysis.predictit.org/'))}`,
      };
    },
    tumblr() {
      return this.analysis === null ? [] : this.analysis;
    },
  },
  methods: {
    ...mapActions('insight', ['getMostPopular', 'getAnalysis']),
  },
  mounted() {
    this.getAnalysis({
      limit: this.numArticles,
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/insights.js